module.exports = __webpack_public_path__ + "static/media/scan_error_sound.e404875b.mp3";